import React from 'react';
import { Modal, Typography, Button } from 'antd';

const { Title, Text } = Typography;

type BenchPolicyModalProps = {
    open: boolean;
    onClose: () => void;
};

const BenchPolicyModal: React.FC<BenchPolicyModalProps> = ({ open, onClose }) => {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            maskClosable={false}
            footer={[
                <Button key="close" type="primary" onClick={onClose}>
                    Close
                </Button>,
            ]}
            title={<Title level={4} className="!mb-0">Bench Policy</Title>}
            width={800}
        >
            <div className="space-y-3 border-t border-gray-200 pt-3">
                <Title className="leading-relaxed" level={5}>
                    Please go through the following points to understand our bench policy:
                </Title>
                <Text className="text-red-600">
                    You are expected to become billable within 15 days of being on the bench. Remaining on the bench for more than 30 days may trigger an HR review or reallocation.
                </Text>
                <div>
                    <Title level={5} className="!mb-1">Contact with Sales / Staffing Team</Title>
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Stay in daily contact with the sales or staffing team for updates on your profile status.</li>
                        <li>Proactively ask the sales team to schedule at least one client interview each day.</li>
                        <li>Start your workday by reaching out to the sales team regarding interview opportunities.</li>
                        <li>Ensure your internal profile is complete and up to date to increase chances of shortlisting.</li>
                        <li>Be responsive to interview coordination and scheduling without delays.</li>
                    </ul>
                </div>
                <div>
                    <Title level={5} className="!mb-1">Interview Performance</Title>
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Prepare thoroughly for client interviews and be punctual for all scheduled rounds.</li>
                        <li>You are expected to clear at least one L1 round out of every 5 client interview rounds.</li>
                        <li>If more than 20 client interviews are scheduled and none are cleared, it may lead to an HR review and possible reallocation.</li>
                    </ul>
                </div>
                <div>
                    <Title level={5} className="!mb-1">Skill Development & Sharing</Title>
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Keep your technical and functional skills up to date during the bench period.</li>
                        <li>Identify and learn new skills where you struggled to answer in past client interviews.</li>
                        <li>Share your updated skill sets with the sales team regularly and on time.</li>
                        <li>Proactively enroll in relevant internal/external learning modules or certifications.</li>
                        <li>Completion of assigned learning modules is mandatory during bench time.</li>
                        <li>Regular progress updates may be reviewed by the L&D team or reporting manager.</li>
                    </ul>
                </div>
                <div>
                    <Title level={5} className="!mb-1">Leaves</Title>
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Paid leaves are not permitted while you are on the bench.</li>
                        <li>Emergency or unpaid leaves require manager approval.</li>
                        <li>Planned vacations should be rescheduled once you are allocated to a project.</li>
                    </ul>
                </div>
                <div>
                    <Title level={5} className="!mb-1">Relocation</Title>
                    <ul className="list-disc pl-5 space-y-1">
                        <li>You must be ready to relocate as per project requirements at short notice.</li>
                        <li>Ensure your documents and readiness for deployment are up to date.</li>
                    </ul>
                </div>
                <div>
                    <Title level={5} className="!mb-1">General Guidelines</Title>
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Maintain attendance and working hours as expected during project time.</li>
                        <li>Ensure professional behavior and availability during business hours.</li>
                    </ul>
                </div>
            </div>
        </Modal>
    );
};

export default BenchPolicyModal;
